import React from 'react'
import Breadcrumb from '../components/Breadcrumbs'
import { Link } from 'react-router-dom'

function Printers() {
    return (
        <div>
            <Breadcrumb title="ID Card Printers" subtitle="Printers" />
            
            <section className="service-grid-area pt-120 pb-90">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-xl-12">
                            <div className="section-title text-center mb-50">
                                <h6 className="subtitle">Official Distributor</h6>
                                <h2 className="title">Entrust Sigma Series & More</h2>
                                <p>We offer the complete range of Entrust (formerly Datacard) and Evolis printers, known for reliability, security, and print quality.</p>
                            </div>
                        </div>
                    </div>

                    <div className="row gy-4">
                        {/* Entrust Sigma DS3 */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="printer-card mb-30">
                                <div className="printer-card-img">
                                    <img src="assets/imgs/printers/ds3.jpg" alt="Entrust Sigma DS3" />
                                </div>
                                <div className="printer-card-content">
                                    <h4 className="service-item-2__title"><Link to="/contact?interest=Entrust+Sigma+DS3">Entrust Sigma DS3</Link></h4>
                                    <p>The next generation of direct-to-card printing. High speed, cloud-ready, and highly secure.</p>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Superior Speed</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Tactile Impression</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Cloud Issuance</li>
                                    </ul>
                                    <Link to="/contact?interest=Entrust+Sigma+DS3" className="rr-btn btn-small">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Entrust Sigma DS2 */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="printer-card mb-30">
                                <div className="printer-card-img">
                                    <img src="assets/imgs/printers/ds2.png" alt="Entrust Sigma DS2" />
                                </div>
                                <div className="printer-card-content">
                                    <h4 className="service-item-2__title"><Link to="/contact?interest=Entrust+Sigma+DS2">Entrust Sigma DS2</Link></h4>
                                    <p>Ideal for businesses needing secure, double-sided card issuance.</p>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Dual-Sided Printing</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> UV Security Printing</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Mobile issuance</li>
                                    </ul>
                                    <Link to="/contact?interest=Entrust+Sigma+DS2" className="rr-btn btn-small">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                         {/* Entrust Sigma DS1 */}
                         <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="printer-card mb-30">
                                <div className="printer-card-img">
                                    <img src="assets/imgs/printers/ds1.jpg" alt="Entrust Sigma DS1" />
                                </div>
                                <div className="printer-card-content">
                                    <h4 className="service-item-2__title"><Link to="/contact?interest=Entrust+Sigma+DS1">Entrust Sigma DS1</Link></h4>
                                    <p>Affordable, entry-level direct-to-card printer for lower volume needs.</p>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Single-Sided</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Easy to use</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Physical Lock Option</li>
                                    </ul>
                                    <Link to="/contact?interest=Entrust+Sigma+DS1" className="rr-btn btn-small">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                         {/* Evolis Primacy 2 */}
                         <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="printer-card mb-30">
                                <div className="printer-card-img">
                                    <img src="assets/imgs/printers/evolis.jpg" alt="Evolis Primacy 2" />
                                </div>
                                <div className="printer-card-content">
                                    <h4 className="service-item-2__title"><Link to="/contact?interest=Evolis+Primacy+2">Evolis Primacy 2</Link></h4>
                                    <p>High-performance card printer. One of the fastest on the market.</p>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> High Capacity Feeder</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Rewrite Technology</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Smartphone/Tablet Support</li>
                                    </ul>
                                    <Link to="/contact?interest=Evolis+Primacy+2" className="rr-btn btn-small">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Zebra ZC300 */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="printer-card mb-30">
                                <div className="printer-card-img">
                                    <img src="assets/imgs/printers/zebra.jpg" alt="Zebra ZC300" />
                                </div>
                                <div className="printer-card-content">
                                    <h4 className="service-item-2__title"><Link to="/contact?interest=Zebra+ZC300">Zebra ZC300</Link></h4>
                                    <p>Simplistic design with ground-breaking simplicity.</p>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Plug and Play</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Space saving design</li>
                                    </ul>
                                    <Link to="/contact?interest=Zebra+ZC300" className="rr-btn btn-small">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                        {/* Magicard 300 */}
                        <div className="col-xl-4 col-lg-6 col-md-6">
                            <div className="printer-card mb-30">
                                <div className="printer-card-img">
                                    <img src="assets/imgs/printers/magicard.webp" alt="Magicard 300" />
                                </div>
                                <div className="printer-card-content">
                                    <h4 className="service-item-2__title"><Link to="/contact?interest=Magicard+300">Magicard 300</Link></h4>
                                    <p>Robust, durable and reliable. Perfect for schools and colleges.</p>
                                    <ul className="list-unstyled mt-3 mb-4">
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> HoloKote Security</li>
                                        <li><i className="fa-solid fa-check text-primary me-2"></i> Digital Shredding</li>
                                    </ul>
                                    <Link to="/contact?interest=Magicard+300" className="rr-btn btn-small">Get Quote <i className="fa-solid fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default Printers
